import { service } from '@/common/request/request.js'

// 邮箱认证
export function authEmail(data = {}) {
  return service({
    url: '/loged/confirmEmail',
    method: 'post',
    data
  })
}

// 邮箱认证
export function authPhone(data = {}) {
  return service({
    url: '/loged/confirmPhone',
    method: 'post',
    data
  })
}

// 实名认证
export function authRealName(data = {}) {
  return service({
    url: '/loged/confirmRealName',
    method: 'post',
    data
  })
}

// QQ实名
export function authQQ(data = {}) {
  return service({
    url: '/loged/confirmQQ',
    method: 'post',
    data
  })
}

// 微信认证
export function authWeChat(data = {}) {
  return service({
    url: '/loged/confirmWeChat',
    method: 'post',
    data
  })
}

// 发送邮箱验证
export function sendEmailCode(data = {}) {
  return service({
    url: '/loged/email',
    method: 'post',
    data
  })
}

// 修改邮箱
export function updateEmail(data = {}) {
  return service({
    url: '/loged/updateEmail',
    method: 'post',
    data
  })
}

// 0发送手机验证码
export function sendPhoneCode(data = {}) {
  return service({
    url: '/loged/sendPhone',
    method: 'post',
    data
  })
}

// (多彩宝)获取电话国家列表
export function getCountryList(data = {}) {
  return service({
    url: '/guest/search/queryCountryList',
    method: 'post',
    data
  })
}

// (多彩宝)发送验证码
export function sendPhoneSMS(data = {}) {
  return service({
    url: '/loged/sendPhoneSMS',
    method: 'post',
    data
  })
}

// 绑定生日
export function updateBirthDay(data = {}) {
  return service({
    url: '/vipDeposit/submitBirthDay',
    method: 'post',
    data
  })
}

// 修改用户 birthday/Facebook/Whatsapp
export function updateUserInfo(data = {}) {
  return service({
    url: '/userAccount/userInfo',
    method: 'post',
    data
  })
}

// 查询埋点事件列表
export function queryListBuried(data = {}) {
  return service({
    url: '/deposit/queryListBuried',
    method: 'post',
    data
  })
}

// 修改埋点上传状态
export function updateBuried(data = {}) {
  return service({
    url: '/deposit/updateBuried',
    method: 'post',
    data
  })
}

export function getVerifyParam(data = {}) {
  return service({
    url: '/guest/getVerifyParam',
    method: 'post',
    data
  })
}
export function updateUserPhone(data = {}) {
  return service({
    url: '/userAccount/updateUserInfo',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/common/api/bindAuthenticate.js